import { forwardRef, useCallback } from 'react';
import { Alert, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CustomContentProps, useSnackbar } from 'notistack';

import { NotificationVariant } from 'types/snackbar';

interface Props extends CustomContentProps {
    closable?: boolean;
    inFooter?: boolean;
    variant: NotificationVariant;
    action?: React.ReactNode;
}
export const NotificationsMessage = forwardRef<HTMLDivElement, Props>(
    ({ id, message, action, inFooter = false, closable = false }, ref) => {
        const { closeSnackbar } = useSnackbar();

        const handleClose = useCallback(() => closeSnackbar(id), [id, closeSnackbar]);

        const hasFooterActions = !!action && inFooter;
        const hasActions = (!!action || closable) && !hasFooterActions;
        return (
            <Alert
                ref={ref}
                data-action={hasFooterActions ? 'footer' : 'standard'}
                icon={false}
                action={
                    hasActions && (
                        <Box display="inline-flex" alignItems="center" paddingRight={0}>
                            {action}
                            {closable && (
                                <IconButton aria-label="close" size="small" onClick={handleClose}>
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            )}
                        </Box>
                    )
                }
            >
                <Typography component="p" color="inherit" lineHeight="20px" fontSize="14px">
                    {message}
                    {hasFooterActions && (
                        <Box display="flex" alignItems="center" justifyContent="flex-end" mt={2.5}>
                            {action}
                            {closable && (
                                <IconButton aria-label="close" size="small" onClick={handleClose}>
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            )}
                        </Box>
                    )}
                </Typography>
            </Alert>
        );
    },
);
